<template>
    <div id="premium_modal" class="f-modal">
        <div v-if="!verFuncionalidades && !verObrigado" v-loading="loading" class="f-modal-content" :style="`background-image: url(${require('@/assets/premium/pattern.png')}); background-repeat: no-repeat;`">
            <span class="fa fa-times f-close" @click="close"></span>
            <div class="f-modal-header">
                <h2>Premium</h2>
            </div>
            <div class="f-modal-body">
                <p style="max-width:300px">
                    Com o Painel Premium você tem acesso a outras funcionalidades que irão te ajudar ainda mais na gestão da sua rede!
                </p>
            </div>
            <img class="f-img-arte" :src="require('@/assets/premium/arte.png')" alt="Imagem arte premium">
            <div class="f-modal-footer">
                <span class="premium-tag-s" @click="verFuncionalidades = true">
                    <b>Ver funcionalidades</b>
                </span>
            </div>
        </div>

        <div v-if="verFuncionalidades" v-loading="loading" class="f-modal-funcionalidades" :style="`background-image: url(${require('@/assets/premium/pattern.png')}); background-size: cover; text-align:center;`">
            <span class="fa fa-times f-close" @click="close"></span>
            <h3 style="color: #22396c;">Compare os planos</h3>
            <h4 style="color: #4e4e4e;">Painel do Franqueador Ilimitado para as suas necessidades.</h4>
            <div class="f-modal-body"><!-- TABLE -->
                <table class="premium-table">
                    <thead>
                        <tr>
                            <th scope="col" class="t-plan0"></th>
                            <th scope="col" class="t-plan t-plan1" style="background-color: #efb20e; color: #16223d;">Starter</th>
                            <th scope="col" class="t-plan t-plan2" style="background-color: #ffc41f; color: #16223d;">Premium</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" class="row-header">Dashboards personalizáveis</th>
                            <td class="t-plan1"><i class="fas fa-check"></i></td>
                            <td class="t-plan2"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">DRE</th>
                            <td class="t-plan1 colored"><i class="fas fa-check"></i></td>
                            <td class="t-plan2 colored"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">DFC</th>
                            <td class="t-plan1"><i class="fas fa-check"></i></td>
                            <td class="t-plan2"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Criação de clusters</th>
                            <td class="t-plan1 colored"><i class="fas fa-check"></i></td>
                            <td class="t-plan2 colored"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Exportação de relatórios</th>
                            <td class="t-plan1"><i class="fas fa-times"></i></td>
                            <td class="t-plan2"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Cluster dinâmico</th>
                            <td class="t-plan1 colored"><i class="fas fa-times"></i></td>
                            <td class="t-plan2 colored"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Detalhamento de DRE</th>
                            <td class="t-plan1"><i class="fas fa-times"></i></td>
                            <td class="t-plan2"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Exportação de dashboards</th>
                            <td class="t-plan1 colored"><i class="fas fa-times"></i></td>
                            <td class="t-plan2 colored"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Apis</th>
                            <td class="t-plan1"><i class="fas fa-times"></i></td>
                            <td class="t-plan2"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Gestão de acessos</th>
                            <td class="t-plan1 colored"><i class="fas fa-times"></i></td>
                            <td class="t-plan2 colored"><i class="fas fa-check"></i></td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Base histórica</th>
                            <td class="t-plan1">1 ano</td>
                            <td class="t-plan2">3 anos</td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header">Sincronização</th>
                            <td class="t-plan1 colored">1x Loja/Mês</td>
                            <td class="t-plan2 colored">Ilimitado</td>
                        </tr>
                        <tr>
                            <th scope="row" class="row-header bottom-radius">Users</th>
                            <td class="t-plan1 bottom-radius">3 Ativos</td>
                            <td class="t-plan2 bottom-radius">Ilimitado</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="f-modal-footer">
                <span class="premium-tag-s" @click="solicitarPremium">
                    <b>Quero ser premium</b>
                </span>
            </div>
        </div>
        
        <div v-if="verObrigado" v-loading="loading" class="f-modal-content" :style="`background-image: url(${require('@/assets/premium/pattern.png')}); background-repeat: no-repeat; text-align: center;`">
            <span class="fa fa-times f-close" @click="close"></span>
            <div class="f-modal-header text-center">
                <h2>Obrigado!</h2>
            </div>
            <img style="width: 290px; margin: 20px 0;" :src="require('@/assets/premium/arte2.png')" alt="Imagem premium arte 2">
            <div class="f-modal-footer">
                <p><b style="color:#f00">Em breve</b> um consultor entrará em contato.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "premium-feature",
    data() {
        return {
            verFuncionalidades: false,
            verObrigado: false,
            loading: false
        }
    },
    methods: {
        close() {
            this.verFuncionalidades = false;
            this.showModalPremium('close')
        },
        async solicitarPremium() {
            this.loading = true
            let request = await this.axios.post(this.$urls.CLIENTE_SOLICITAR_PREMIUM);

            this.loading = false
            if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            this.verFuncionalidades = false;
            this.verObrigado = true;
            localStorage.setItem('solicitacaoPremium','enviada')
        }
    },
    mounted() {
        if(localStorage.getItem('solicitacaoPremium')) {
            this.verObrigado = true;
        }
    }
}
</script>

<style lang="scss">
    .f-modal {
        display: none;
        position: fixed; 
        z-index: 2050;
        left: 0;
        top: 0;
        width: 100%; 
        height: 100%; 
        overflow: auto; 
        background-color: rgba(0,0,0,0.4);
        transition:0.2s;
        .f-modal-content {
            background-color: #fff;
            min-height:360px;
            margin: 5% auto; 
            padding: 35px 35px 60px;
            width: 80%; 
            max-width: 800px; 
            border-radius: 10px;
            box-shadow: 1px 1px 1px #ccc;
            position:relative;
            transition:0.2s;
            .f-close {
                position:absolute;
                right: 10px;
                top: 10px;
                cursor:pointer !important;
                padding: 7px 9px;
                border-radius: 25px;
                transition:0.2s;
                &:hover {
                    background: #ebebeb;
                }
            }
        }
        .f-modal-header {
            h2 {
                font-size: 3.5em;
                font-weight: 900;
                margin:0 -4px;
            }
        }
        .f-modal-body {
            margin: 45px 0;
            position: relative;
            z-index: 1;
        }
        .f-modal-footer {
            .premium-tag-s {
                position: relative;
                display: inline-block;
                float: none;
                font-size: 19px !important;
                padding: 10px 30px 15px;
                border-radius: 14px;
                border-radius: 20px;
                color:#16223d !important;
                border: 1px solid #00adee;
                background: #00adee;
                &:hover {
                    background: #45bce9;
                }
            }
        }
        .f-img-arte{
            min-width: 300px;
            display: block;
            position: absolute;
            right: 30px;
            top: 100px;
        }
        @media (max-width: 700px) {
            .f-img-arte{
                display: none;
            }
            .f-modal-body {
                width: 100%;
            }
            .f-modal .f-modal-footer .premium-tag-s {
                width: 100%;
                text-align: center;
            }
        }
        .f-modal-funcionalidades {
            background-color: #fff;
            min-height:460px;
            margin: 5% auto; 
            padding: 35px 35px 60px;
            width: 80%; 
            max-width: 800px; 
            border-radius: 10px;
            box-shadow: 1px 1xp 1px #ccc;
            position:relative;
            transition:0.2s;
            position:relative;
            .f-close {
                position:absolute;
                right: 10px;
                top: 10px;
                cursor:pointer !important;
                padding: 7px 9px;
                border-radius: 25px;
                transition:0.2s;
                &:hover {
                    background: #ebebeb;
                }
            }
            span.premium-tag-s {
                text-align: center;
                margin: 0 auto;
                display: block !important;
                max-width: 250px;
            }
            .premium-table {
                margin: 0 auto;
                color: #16223d;
                .bottom-radius {
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                tr td {
                    padding:5px;
                    font-size: 12px;
                }
                tbody th {
                    font-size: 12px;
                    font-weight: 900 !important;
                }
                .t-plan0 {
                    width:190px; 
                    border-top-left-radius: 20px; 
                    border-top-right-radius: 20px;
                }
                .t-plan {
                    border-top-left-radius: 20px;
                    border-top-right-radius: 20px;
                    font-weight: 900 !important;
                    padding: 15px 0 !important;
                }
                th.t-plan1, th.t-plan2 {
                    font-size: 12px;
                    padding: 9px 0px;
                    width: 150px;
                }
                td.t-plan1 {
                    background: #dadadd !important;
                    &.colored {
                        background-color: #d0d0d3 !important;
                    }
                }
                td.t-plan2 {
                    background: #d2d2d6 !important;
                    &.colored {
                        background-color: #cbcbcf !important;
                    }
                }
                td, th, button, .row-header {
                    font-weight: initial;
                }
                thead, tbody {
                    text-align: center;
                }
                .fa-check {
                    color: #42b255;
                    font-size: 20px;
                }
                .fa-times{
                    color: #e30d13;
                    font-size: 20px;
                }
                tr  {
                    background-color: #e0e0e3;
                    &:nth-child(odd) {
                        background-color: #f2f2f2;
                    }
                }
            }

        }
    }
    
</style>
